<template>
  <div
    class="card"
    :class="{ 'loading': isLoading, 'disabled': isDisabled }"
    v-aha-emit-action
    :name="actionName"
    :aha-other-info="ahaOtherInfo"
    :data-presentation-id="dataPresentationId"
    @click="$emit('click')"
    @keydown.enter="$emit('click')"
    tabindex="0"
    role="button"
    :aria-disabled="isDisabled"
  >
    <div class="icon-container" :style="{ backgroundColor: bgColor }">
      <aha-icon
        :name="icon.name"
        :width="icon.width || 20"
        :height="icon.height || 20"
        :viewBox="icon.viewBox || '0 0 24 24'"
      />
    </div>
    <div class="card-content">
      <h3 class="card-title">
        {{ title }}
      </h3>
      <p class="card-description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingCard',
  props: {
    icon: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        viewBox: '0 0 24 24',
        width: 20,
        height: 20,
      }),
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: '#3E3E5A',
    },
    actionName: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    ahaOtherInfo: {
      type: String,
      default: '',
    },
    dataPresentationId: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex: 1 0 auto;
  padding: 8px;
  background-color: #fff;
  border-radius: 12px;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background-color: #F5F5F5;
  }

  &.loading {
    pointer-events: none;

    .icon-container {
      position: relative;

      svg {
        opacity: 0;
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 20px;
        height: 20px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        z-index: 1;
      }
    }
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}

.icon-container {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  color: #ffffff;
  position: relative;
}

.card-content {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

.card-description {
  font-size: 12px;
  margin: 0;
  display: none;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@media (min-width: 1422px) { // scrollbar width ~ 17px
  .card {
    padding: 16px;
  }

  .card-description {
    display: block;
  }
}
</style>
